import {LoginPayload, LoginResponse} from "@/app/auth/login/login.entity.ts";
import {AuthRepository} from "@/repositories/auth.repository.ts";

export async function login(payload: LoginPayload): Promise<LoginResponse> {
    return AuthRepository.loginWithEmail(payload);
}